import { axios } from '@/api/request'

/**
 * api接口列表
 */
const api = {

  sendorderdetail:'/teams/sendorder/',
  peisongproducts:'/teams/chukulog/',
  peisongdone:'/teams/sendorder/',
  getAuthorization:'/teams/getAuthorization/',
  savepics:'/teams/sendorder/'

}

export function getAuthorization (params) {
  return axios({
    url: api.getAuthorization,
    method: 'get',
    params
  })
}

export function savepics (data) {
  return axios({
    url: api.savepics+data.id+'/',
    method: 'put',
    data
  })
}


export function sendorderdetail (id) {
  return axios({
    url: api.sendorderdetail+id+'/',
    method: 'get',

  })
}
export function peisongproducts (params) {
  return axios({
    url: api.peisongproducts,
    method: 'get',
    params
  })
}
export function peisongdone (data) {
  return axios({
    url: api.peisongdone+data.id+'/',
    method: 'put',
    data

  })
}



// WEBPACK FOOTER //
// ./src/views/cangkuviews/sendorderdetail/api.js